import { isDOM } from '@app/shared/predicates'
import { abort } from '@app/adapters/abort'
/**
 * Sets up a global listener to abort any ongoing left drawer requests when navigating away from the current page.
 * This ensures that we don't have any unresolved promises or ongoing fetch requests related to the left drawer
 * when the user navigates to a different page, which could lead to memory leaks or unwanted side effects.
 *
 * The listener is added on DOM load and will be triggered before any Turbolinks visit, allowing us to clean up
 * any pending operations in the left drawer before the new page is loaded.
 */
window.onDomLoad(function ($dom) {
  if (!isDOM($dom[0])) return

  document.addEventListener(
    'turbolinks:before-visit',
    () => abort('leftDrawer'),
    {
      once: true,
    }
  )
})
